var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/.pnpm/events@3.3.0/node_modules/events/events.js
var require_events = __commonJS({
  "node_modules/.pnpm/events@3.3.0/node_modules/events/events.js"(exports, module) {
    "use strict";
    var R = typeof Reflect === "object" ? Reflect : null;
    var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply2(target, receiver, args) {
      return Function.prototype.apply.call(target, receiver, args);
    };
    var ReflectOwnKeys;
    if (R && typeof R.ownKeys === "function") {
      ReflectOwnKeys = R.ownKeys;
    } else if (Object.getOwnPropertySymbols) {
      ReflectOwnKeys = function ReflectOwnKeys2(target) {
        return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
      };
    } else {
      ReflectOwnKeys = function ReflectOwnKeys2(target) {
        return Object.getOwnPropertyNames(target);
      };
    }
    function ProcessEmitWarning(warning) {
      if (console && console.warn)
      console.warn(warning);
    }
    var NumberIsNaN = Number.isNaN || function NumberIsNaN2(value) {
      return value !== value;
    };
    function EventEmitter2() {
      EventEmitter2.init.call(this);
    }
    module.exports = EventEmitter2;
    module.exports.once = once;
    EventEmitter2.EventEmitter = EventEmitter2;
    EventEmitter2.prototype._events = void 0;
    EventEmitter2.prototype._eventsCount = 0;
    EventEmitter2.prototype._maxListeners = void 0;
    var defaultMaxListeners = 10;
    function checkListener(listener) {
      if (typeof listener !== "function") {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
    }
    Object.defineProperty(EventEmitter2, "defaultMaxListeners", {
      enumerable: true,
      get: function() {
        return defaultMaxListeners;
      },
      set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) {
          throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        }
        defaultMaxListeners = arg;
      }
    });
    EventEmitter2.init = function() {
      if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
        this._events = /* @__PURE__ */ Object.create(null);
        this._eventsCount = 0;
      }
      this._maxListeners = this._maxListeners || void 0;
    };
    EventEmitter2.prototype.setMaxListeners = function setMaxListeners(n) {
      if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) {
        throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
      }
      this._maxListeners = n;
      return this;
    };
    function _getMaxListeners(that) {
      if (that._maxListeners === void 0)
        return EventEmitter2.defaultMaxListeners;
      return that._maxListeners;
    }
    EventEmitter2.prototype.getMaxListeners = function getMaxListeners() {
      return _getMaxListeners(this);
    };
    EventEmitter2.prototype.emit = function emit(type) {
      var args = [];
      for (var i = 1; i < arguments.length; i++)
        args.push(arguments[i]);
      var doError = type === "error";
      var events = this._events;
      if (events !== void 0)
        doError = doError && events.error === void 0;
      else if (!doError)
        return false;
      if (doError) {
        var er;
        if (args.length > 0)
          er = args[0];
        if (er instanceof Error) {
          throw er;
        }
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err;
      }
      var handler = events[type];
      if (handler === void 0)
        return false;
      if (typeof handler === "function") {
        ReflectApply(handler, this, args);
      } else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for (var i = 0; i < len; ++i)
          ReflectApply(listeners[i], this, args);
      }
      return true;
    };
    function _addListener(target, type, listener, prepend) {
      var m;
      var events;
      var existing;
      checkListener(listener);
      events = target._events;
      if (events === void 0) {
        events = target._events = /* @__PURE__ */ Object.create(null);
        target._eventsCount = 0;
      } else {
        if (events.newListener !== void 0) {
          target.emit(
            "newListener",
            type,
            listener.listener ? listener.listener : listener
          );
          events = target._events;
        }
        existing = events[type];
      }
      if (existing === void 0) {
        existing = events[type] = listener;
        ++target._eventsCount;
      } else {
        if (typeof existing === "function") {
          existing = events[type] = prepend ? [listener, existing] : [existing, listener];
        } else if (prepend) {
          existing.unshift(listener);
        } else {
          existing.push(listener);
        }
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
          existing.warned = true;
          var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners added. Use emitter.setMaxListeners() to increase limit");
          w.name = "MaxListenersExceededWarning";
          w.emitter = target;
          w.type = type;
          w.count = existing.length;
          ProcessEmitWarning(w);
        }
      }
      return target;
    }
    EventEmitter2.prototype.addListener = function addListener(type, listener) {
      return _addListener(this, type, listener, false);
    };
    EventEmitter2.prototype.on = EventEmitter2.prototype.addListener;
    EventEmitter2.prototype.prependListener = function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };
    function onceWrapper() {
      if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0)
          return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
      }
    }
    function _onceWrap(target, type, listener) {
      var state = { fired: false, wrapFn: void 0, target, type, listener };
      var wrapped = onceWrapper.bind(state);
      wrapped.listener = listener;
      state.wrapFn = wrapped;
      return wrapped;
    }
    EventEmitter2.prototype.once = function once2(type, listener) {
      checkListener(listener);
      this.on(type, _onceWrap(this, type, listener));
      return this;
    };
    EventEmitter2.prototype.prependOnceListener = function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };
    EventEmitter2.prototype.removeListener = function removeListener(type, listener) {
      var list, events, position, i, originalListener;
      checkListener(listener);
      events = this._events;
      if (events === void 0)
        return this;
      list = events[type];
      if (list === void 0)
        return this;
      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = /* @__PURE__ */ Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit("removeListener", type, list.listener || listener);
        }
      } else if (typeof list !== "function") {
        position = -1;
        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }
        if (position < 0)
          return this;
        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }
        if (list.length === 1)
          events[type] = list[0];
        if (events.removeListener !== void 0)
          this.emit("removeListener", type, originalListener || listener);
      }
      return this;
    };
    EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener;
    EventEmitter2.prototype.removeAllListeners = function removeAllListeners(type) {
      var listeners, events, i;
      events = this._events;
      if (events === void 0)
        return this;
      if (events.removeListener === void 0) {
        if (arguments.length === 0) {
          this._events = /* @__PURE__ */ Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== void 0) {
          if (--this._eventsCount === 0)
            this._events = /* @__PURE__ */ Object.create(null);
          else
            delete events[type];
        }
        return this;
      }
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === "removeListener")
            continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = /* @__PURE__ */ Object.create(null);
        this._eventsCount = 0;
        return this;
      }
      listeners = events[type];
      if (typeof listeners === "function") {
        this.removeListener(type, listeners);
      } else if (listeners !== void 0) {
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }
      return this;
    };
    function _listeners(target, type, unwrap) {
      var events = target._events;
      if (events === void 0)
        return [];
      var evlistener = events[type];
      if (evlistener === void 0)
        return [];
      if (typeof evlistener === "function")
        return unwrap ? [evlistener.listener || evlistener] : [evlistener];
      return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
    }
    EventEmitter2.prototype.listeners = function listeners(type) {
      return _listeners(this, type, true);
    };
    EventEmitter2.prototype.rawListeners = function rawListeners(type) {
      return _listeners(this, type, false);
    };
    EventEmitter2.listenerCount = function(emitter, type) {
      if (typeof emitter.listenerCount === "function") {
        return emitter.listenerCount(type);
      } else {
        return listenerCount.call(emitter, type);
      }
    };
    EventEmitter2.prototype.listenerCount = listenerCount;
    function listenerCount(type) {
      var events = this._events;
      if (events !== void 0) {
        var evlistener = events[type];
        if (typeof evlistener === "function") {
          return 1;
        } else if (evlistener !== void 0) {
          return evlistener.length;
        }
      }
      return 0;
    }
    EventEmitter2.prototype.eventNames = function eventNames() {
      return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
    };
    function arrayClone(arr, n) {
      var copy = new Array(n);
      for (var i = 0; i < n; ++i)
        copy[i] = arr[i];
      return copy;
    }
    function spliceOne(list, index) {
      for (; index + 1 < list.length; index++)
        list[index] = list[index + 1];
      list.pop();
    }
    function unwrapListeners(arr) {
      var ret = new Array(arr.length);
      for (var i = 0; i < ret.length; ++i) {
        ret[i] = arr[i].listener || arr[i];
      }
      return ret;
    }
    function once(emitter, name) {
      return new Promise(function(resolve, reject) {
        function errorListener(err) {
          emitter.removeListener(name, resolver);
          reject(err);
        }
        function resolver() {
          if (typeof emitter.removeListener === "function") {
            emitter.removeListener("error", errorListener);
          }
          resolve([].slice.call(arguments));
        }
        ;
        eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
        if (name !== "error") {
          addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
        }
      });
    }
    function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
      if (typeof emitter.on === "function") {
        eventTargetAgnosticAddListener(emitter, "error", handler, flags);
      }
    }
    function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
      if (typeof emitter.on === "function") {
        if (flags.once) {
          emitter.once(name, listener);
        } else {
          emitter.on(name, listener);
        }
      } else if (typeof emitter.addEventListener === "function") {
        emitter.addEventListener(name, function wrapListener(arg) {
          if (flags.once) {
            emitter.removeEventListener(name, wrapListener);
          }
          listener(arg);
        });
      } else {
        throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
      }
    }
  }
});

// node_modules/.pnpm/reconnecting-websocket@4.4.0/node_modules/reconnecting-websocket/dist/reconnecting-websocket-mjs.js
var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2)
      if (b2.hasOwnProperty(p))
        d2[p] = b2[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function __values(o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
  if (m)
    return m.call(o);
  return {
    next: function() {
      if (o && i >= o.length)
        o = void 0;
      return { value: o && o[i++], done: !o };
    }
  };
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
    ar = ar.concat(__read(arguments[i]));
  return ar;
}
var Event = (
  /** @class */
  /* @__PURE__ */ function() {
    function Event2(type, target) {
      this.target = target;
      this.type = type;
    }
    return Event2;
  }()
);
var ErrorEvent = (
  /** @class */
  function(_super) {
    __extends(ErrorEvent2, _super);
    function ErrorEvent2(error, target) {
      var _this = _super.call(this, "error", target) || this;
      _this.message = error.message;
      _this.error = error;
      return _this;
    }
    return ErrorEvent2;
  }(Event)
);
var CloseEvent = (
  /** @class */
  function(_super) {
    __extends(CloseEvent2, _super);
    function CloseEvent2(code, reason, target) {
      if (code === void 0) {
        code = 1e3;
      }
      if (reason === void 0) {
        reason = "";
      }
      var _this = _super.call(this, "close", target) || this;
      _this.wasClean = true;
      _this.code = code;
      _this.reason = reason;
      return _this;
    }
    return CloseEvent2;
  }(Event)
);
var getGlobalWebSocket = function() {
  if (typeof WebSocket !== "undefined") {
    return WebSocket;
  }
};
var isWebSocket = function(w) {
  return typeof w !== "undefined" && !!w && w.CLOSING === 2;
};
var DEFAULT = {
  maxReconnectionDelay: 1e4,
  minReconnectionDelay: 1e3 + Math.random() * 4e3,
  minUptime: 5e3,
  reconnectionDelayGrowFactor: 1.3,
  connectionTimeout: 4e3,
  maxRetries: Infinity,
  maxEnqueuedMessages: Infinity,
  startClosed: false,
  debug: false
};
var ReconnectingWebSocket = (
  /** @class */
  function() {
    function ReconnectingWebSocket2(url, protocols, options) {
      var _this = this;
      if (options === void 0) {
        options = {};
      }
      this._listeners = {
        error: [],
        message: [],
        open: [],
        close: []
      };
      this._retryCount = -1;
      this._shouldReconnect = true;
      this._connectLock = false;
      this._binaryType = "blob";
      this._closeCalled = false;
      this._messageQueue = [];
      this.onclose = null;
      this.onerror = null;
      this.onmessage = null;
      this.onopen = null;
      this._handleOpen = function(event) {
        _this._debug("open event");
        var _a = _this._options.minUptime, minUptime = _a === void 0 ? DEFAULT.minUptime : _a;
        clearTimeout(_this._connectTimeout);
        _this._uptimeTimeout = setTimeout(function() {
          return _this._acceptOpen();
        }, minUptime);
        _this._ws.binaryType = _this._binaryType;
        _this._messageQueue.forEach(function(message) {
          return _this._ws.send(message);
        });
        _this._messageQueue = [];
        if (_this.onopen) {
          _this.onopen(event);
        }
        _this._listeners.open.forEach(function(listener) {
          return _this._callEventListener(event, listener);
        });
      };
      this._handleMessage = function(event) {
        _this._debug("message event");
        if (_this.onmessage) {
          _this.onmessage(event);
        }
        _this._listeners.message.forEach(function(listener) {
          return _this._callEventListener(event, listener);
        });
      };
      this._handleError = function(event) {
        _this._debug("error event", event.message);
        _this._disconnect(void 0, event.message === "TIMEOUT" ? "timeout" : void 0);
        if (_this.onerror) {
          _this.onerror(event);
        }
        _this._debug("exec error listeners");
        _this._listeners.error.forEach(function(listener) {
          return _this._callEventListener(event, listener);
        });
        _this._connect();
      };
      this._handleClose = function(event) {
        _this._debug("close event");
        _this._clearTimeouts();
        if (_this._shouldReconnect) {
          _this._connect();
        }
        if (_this.onclose) {
          _this.onclose(event);
        }
        _this._listeners.close.forEach(function(listener) {
          return _this._callEventListener(event, listener);
        });
      };
      this._url = url;
      this._protocols = protocols;
      this._options = options;
      if (this._options.startClosed) {
        this._shouldReconnect = false;
      }
      this._connect();
    }
    Object.defineProperty(ReconnectingWebSocket2, "CONNECTING", {
      get: function() {
        return 0;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket2, "OPEN", {
      get: function() {
        return 1;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket2, "CLOSING", {
      get: function() {
        return 2;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket2, "CLOSED", {
      get: function() {
        return 3;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket2.prototype, "CONNECTING", {
      get: function() {
        return ReconnectingWebSocket2.CONNECTING;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket2.prototype, "OPEN", {
      get: function() {
        return ReconnectingWebSocket2.OPEN;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket2.prototype, "CLOSING", {
      get: function() {
        return ReconnectingWebSocket2.CLOSING;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket2.prototype, "CLOSED", {
      get: function() {
        return ReconnectingWebSocket2.CLOSED;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket2.prototype, "binaryType", {
      get: function() {
        return this._ws ? this._ws.binaryType : this._binaryType;
      },
      set: function(value) {
        this._binaryType = value;
        if (this._ws) {
          this._ws.binaryType = value;
        }
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket2.prototype, "retryCount", {
      /**
       * Returns the number or connection retries
       */
      get: function() {
        return Math.max(this._retryCount, 0);
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket2.prototype, "bufferedAmount", {
      /**
       * The number of bytes of data that have been queued using calls to send() but not yet
       * transmitted to the network. This value resets to zero once all queued data has been sent.
       * This value does not reset to zero when the connection is closed; if you keep calling send(),
       * this will continue to climb. Read only
       */
      get: function() {
        var bytes = this._messageQueue.reduce(function(acc, message) {
          if (typeof message === "string") {
            acc += message.length;
          } else if (message instanceof Blob) {
            acc += message.size;
          } else {
            acc += message.byteLength;
          }
          return acc;
        }, 0);
        return bytes + (this._ws ? this._ws.bufferedAmount : 0);
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket2.prototype, "extensions", {
      /**
       * The extensions selected by the server. This is currently only the empty string or a list of
       * extensions as negotiated by the connection
       */
      get: function() {
        return this._ws ? this._ws.extensions : "";
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket2.prototype, "protocol", {
      /**
       * A string indicating the name of the sub-protocol the server selected;
       * this will be one of the strings specified in the protocols parameter when creating the
       * WebSocket object
       */
      get: function() {
        return this._ws ? this._ws.protocol : "";
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket2.prototype, "readyState", {
      /**
       * The current state of the connection; this is one of the Ready state constants
       */
      get: function() {
        if (this._ws) {
          return this._ws.readyState;
        }
        return this._options.startClosed ? ReconnectingWebSocket2.CLOSED : ReconnectingWebSocket2.CONNECTING;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket2.prototype, "url", {
      /**
       * The URL as resolved by the constructor
       */
      get: function() {
        return this._ws ? this._ws.url : "";
      },
      enumerable: true,
      configurable: true
    });
    ReconnectingWebSocket2.prototype.close = function(code, reason) {
      if (code === void 0) {
        code = 1e3;
      }
      this._closeCalled = true;
      this._shouldReconnect = false;
      this._clearTimeouts();
      if (!this._ws) {
        this._debug("close enqueued: no ws instance");
        return;
      }
      if (this._ws.readyState === this.CLOSED) {
        this._debug("close: already closed");
        return;
      }
      this._ws.close(code, reason);
    };
    ReconnectingWebSocket2.prototype.reconnect = function(code, reason) {
      this._shouldReconnect = true;
      this._closeCalled = false;
      this._retryCount = -1;
      if (!this._ws || this._ws.readyState === this.CLOSED) {
        this._connect();
      } else {
        this._disconnect(code, reason);
        this._connect();
      }
    };
    ReconnectingWebSocket2.prototype.send = function(data) {
      if (this._ws && this._ws.readyState === this.OPEN) {
        this._debug("send", data);
        this._ws.send(data);
      } else {
        var _a = this._options.maxEnqueuedMessages, maxEnqueuedMessages = _a === void 0 ? DEFAULT.maxEnqueuedMessages : _a;
        if (this._messageQueue.length < maxEnqueuedMessages) {
          this._debug("enqueue", data);
          this._messageQueue.push(data);
        }
      }
    };
    ReconnectingWebSocket2.prototype.addEventListener = function(type, listener) {
      if (this._listeners[type]) {
        this._listeners[type].push(listener);
      }
    };
    ReconnectingWebSocket2.prototype.dispatchEvent = function(event) {
      var e_1, _a;
      var listeners = this._listeners[event.type];
      if (listeners) {
        try {
          for (var listeners_1 = __values(listeners), listeners_1_1 = listeners_1.next(); !listeners_1_1.done; listeners_1_1 = listeners_1.next()) {
            var listener = listeners_1_1.value;
            this._callEventListener(event, listener);
          }
        } catch (e_1_1) {
          e_1 = { error: e_1_1 };
        } finally {
          try {
            if (listeners_1_1 && !listeners_1_1.done && (_a = listeners_1.return))
              _a.call(listeners_1);
          } finally {
            if (e_1)
              throw e_1.error;
          }
        }
      }
      return true;
    };
    ReconnectingWebSocket2.prototype.removeEventListener = function(type, listener) {
      if (this._listeners[type]) {
        this._listeners[type] = this._listeners[type].filter(function(l) {
          return l !== listener;
        });
      }
    };
    ReconnectingWebSocket2.prototype._debug = function() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      if (this._options.debug) {
       // console.log.apply(console, __spread(["RWS>"], args));
      }
    };
    ReconnectingWebSocket2.prototype._getNextDelay = function() {
      var _a = this._options, _b = _a.reconnectionDelayGrowFactor, reconnectionDelayGrowFactor = _b === void 0 ? DEFAULT.reconnectionDelayGrowFactor : _b, _c = _a.minReconnectionDelay, minReconnectionDelay = _c === void 0 ? DEFAULT.minReconnectionDelay : _c, _d = _a.maxReconnectionDelay, maxReconnectionDelay = _d === void 0 ? DEFAULT.maxReconnectionDelay : _d;
      var delay = 0;
      if (this._retryCount > 0) {
        delay = minReconnectionDelay * Math.pow(reconnectionDelayGrowFactor, this._retryCount - 1);
        if (delay > maxReconnectionDelay) {
          delay = maxReconnectionDelay;
        }
      }
      this._debug("next delay", delay);
      return delay;
    };
    ReconnectingWebSocket2.prototype._wait = function() {
      var _this = this;
      return new Promise(function(resolve) {
        setTimeout(resolve, _this._getNextDelay());
      });
    };
    ReconnectingWebSocket2.prototype._getNextUrl = function(urlProvider) {
      if (typeof urlProvider === "string") {
        return Promise.resolve(urlProvider);
      }
      if (typeof urlProvider === "function") {
        var url = urlProvider();
        if (typeof url === "string") {
          return Promise.resolve(url);
        }
        if (!!url.then) {
          return url;
        }
      }
      throw Error("Invalid URL");
    };
    ReconnectingWebSocket2.prototype._connect = function() {
      var _this = this;
      if (this._connectLock || !this._shouldReconnect) {
        return;
      }
      this._connectLock = true;
      var _a = this._options, _b = _a.maxRetries, maxRetries = _b === void 0 ? DEFAULT.maxRetries : _b, _c = _a.connectionTimeout, connectionTimeout = _c === void 0 ? DEFAULT.connectionTimeout : _c, _d = _a.WebSocket, WebSocket2 = _d === void 0 ? getGlobalWebSocket() : _d;
      if (this._retryCount >= maxRetries) {
        this._debug("max retries reached", this._retryCount, ">=", maxRetries);
        return;
      }
      this._retryCount++;
      this._debug("connect", this._retryCount);
      this._removeListeners();
      if (!isWebSocket(WebSocket2)) {
        throw Error("No valid WebSocket class provided");
      }
      this._wait().then(function() {
        return _this._getNextUrl(_this._url);
      }).then(function(url) {
        if (_this._closeCalled) {
          return;
        }
        _this._debug("connect", { url, protocols: _this._protocols });
        _this._ws = _this._protocols ? new WebSocket2(url, _this._protocols) : new WebSocket2(url);
        _this._ws.binaryType = _this._binaryType;
        _this._connectLock = false;
        _this._addListeners();
        _this._connectTimeout = setTimeout(function() {
          return _this._handleTimeout();
        }, connectionTimeout);
      });
    };
    ReconnectingWebSocket2.prototype._handleTimeout = function() {
      this._debug("timeout event");
      this._handleError(new ErrorEvent(Error("TIMEOUT"), this));
    };
    ReconnectingWebSocket2.prototype._disconnect = function(code, reason) {
      if (code === void 0) {
        code = 1e3;
      }
      this._clearTimeouts();
      if (!this._ws) {
        return;
      }
      this._removeListeners();
      try {
        this._ws.close(code, reason);
        this._handleClose(new CloseEvent(code, reason, this));
      } catch (error) {
      }
    };
    ReconnectingWebSocket2.prototype._acceptOpen = function() {
      this._debug("accept open");
      this._retryCount = 0;
    };
    ReconnectingWebSocket2.prototype._callEventListener = function(event, listener) {
      if ("handleEvent" in listener) {
        listener.handleEvent(event);
      } else {
        listener(event);
      }
    };
    ReconnectingWebSocket2.prototype._removeListeners = function() {
      if (!this._ws) {
        return;
      }
      this._debug("removeListeners");
      this._ws.removeEventListener("open", this._handleOpen);
      this._ws.removeEventListener("close", this._handleClose);
      this._ws.removeEventListener("message", this._handleMessage);
      this._ws.removeEventListener("error", this._handleError);
    };
    ReconnectingWebSocket2.prototype._addListeners = function() {
      if (!this._ws) {
        return;
      }
      this._debug("addListeners");
      this._ws.addEventListener("open", this._handleOpen);
      this._ws.addEventListener("close", this._handleClose);
      this._ws.addEventListener("message", this._handleMessage);
      this._ws.addEventListener("error", this._handleError);
    };
    ReconnectingWebSocket2.prototype._clearTimeouts = function() {
      clearTimeout(this._connectTimeout);
      clearTimeout(this._uptimeTimeout);
    };
    return ReconnectingWebSocket2;
  }()
);
var reconnecting_websocket_mjs_default = ReconnectingWebSocket;

// src/vasconnect.ts
var import_events = __toESM(require_events());
function uuidv4() {
  return ("10000000-1000-4000-8000" + -1e11).replace(
    /[018]/g,
    (c) => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}
var ONLINE_CHECKIN_URL = "https://gls.estdemos.com/api/public/vasconnect/checkin";
var DEFAULT_HOST = "http://localhost:54347";
var LOCALSTORAGE_KEY = "vasconnect-api-key";
var LOCALSTORAGE_KEY_APP_ID = "vasconnect-api-app-id";
var hasIntantiatedBefore = false;
function getAppIdFromLicenseToken(token) {
  if (token.startsWith("online:")) {
    return token.split(":")[1];
  } else if (token.startsWith("gui:")) {
    return token.split(":")[1];
  } else {
    const parsed = parseLicenseToken(token);
    return parsed.vas_connect.app_id;
  }
}
function parseLicenseToken(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64).split("").map(function(c) {
      return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join("")
  );
  return JSON.parse(jsonPayload);
}
function log(message) {
  // console.log(`vasconnect-js: ${message}`);
}
var RequestHandler = class {
  constructor(host) {
    this.host = host;
  }
  setSecret(secret) {
    this.secret = secret;
  }
  getSecret() {
    return this.secret;
  }
  hasSecretSet() {
    return Boolean(this.secret);
  }
  async makeRequest(path, options) {
    const result = await fetch(`${this.host}${path}`, {
      method: options?.method || "GET",
      headers: {
        Accept: "application/json",
        Authorization: this.secret || "",
        "Content-Type": "application/json"
      },
      body: options?.body ? JSON.stringify(options?.body) : null
    });
    if (result.status !== 200) {
      throw new Error(`Got invallid status ${result.status}`);
    }
    if (result.headers.get("Content-Type") === "application/json") {
      const json = await result.json();
      if (json.error) {
        throw new Error(
          `Web service returned an error: ${json.error.toString()}`
        );
      }
      return json;
    }
  }
};
var VASConnect = class extends import_events.EventEmitter {
  constructor(options) {
    super();
    this.lastUpdateId = null;
    this.lastUpdateEpoch = null;
    this.wsHealthy = false;
    this.hasTriedToAuthorize = false;
    this.scriptVersion = "1.5.15";
    this.serverVersion = null;
    if (hasIntantiatedBefore) {
      // console.error(
      //   `VASConnect: Multiple instances of VASConnect have been created. This is probably a bug in the application code. Only one instance of VASConnect should be created. You may see unusual behavior until this is corrected.`
      // );
    }
    hasIntantiatedBefore = true;
    this.appId = getAppIdFromLicenseToken(options.licenseToken);
    this.licenseToken = options.licenseToken;
    this.host = options?.host || DEFAULT_HOST;
    this.rh = new RequestHandler(this.host);
    if (options?.secret) {
      log("using secret passed to constructor");
      this.rh.setSecret(options.secret);
    } else if (window["vasconnectApiKey"]) {
      // console.log("using secret injected on window object");
      this.rh.setSecret(window["vasconnectApiKey"]);
    } else {
      const storedAuthKey = window.localStorage.getItem(LOCALSTORAGE_KEY);
      const storedAppId = window.localStorage.getItem(LOCALSTORAGE_KEY_APP_ID);
      if (storedAuthKey && storedAppId === this.appId) {
        log("using secret from localstorage");
        this.rh.setSecret(storedAuthKey);
      } else {
        window.localStorage.removeItem(LOCALSTORAGE_KEY);
        window.localStorage.removeItem(LOCALSTORAGE_KEY_APP_ID);
      }
    }
    this.connectionStatus = "disconnected";
    this.runConnectionLoop(options?.connectionStatusPollingInterval || 1e3);
    const authorizeAutomatically = options?.authorizeAutomatically ?? true;
    if (authorizeAutomatically) {
      const listener = (newStatus) => {
        if (newStatus === "unauthorized" && !this.hasTriedToAuthorize) {
          this.authorize();
          this.off("connectionStatusChange", listener);
        }
      };
      this.on("connectionStatusChange", listener);
    }
  }
  async checkinOnlineForToken(token) {
    const result = await fetch(
      ONLINE_CHECKIN_URL,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          clientName: "VASConnect.js",
          clientVersion: this.scriptVersion,
          vasconnectVersion: this.serverVersion,
          licenseToken: token
        })
      }
    );
    if (result.status !== 200) {
      throw new Error(`Failed to upgrade token. Status code: ${result.status}`);
    }
    const body = await result.json();
    const licenseToken = body.licenseToken;
    if (!licenseToken) {
      throw new Error(`Failed to upgrade token. No license token returned.`);
    }
    return licenseToken;
  }
  async runConnectionLoop(interval) {
    const schedule = () => {
      if (interval !== void 0) {
        setTimeout(
          () => {
            this.runConnectionLoop(interval);
          },
          1e3,
          interval
        );
      }
    };
    if (this.connectionStatus === "websocket") {
      return schedule();
    }
    try {
      const isAuthorized = await this.isAuthorized();
      if (isAuthorized) {
        this.updateConnectionStatus("authorized");
      } else {
        this.updateConnectionStatus("unauthorized");
      }
    } catch (e) {
      this.updateConnectionStatus("disconnected");
    }
    return schedule();
  }
  initializeWebSocket() {
    log("initializing websocket...");
    const secret = this.rh.getSecret();
    this.ws = new reconnecting_websocket_mjs_default(
      `ws://localhost:54347/ws?token=${secret}`
    );
    this.ws.onopen = () => {
      log("ws.onopen");
      this.wsHealthy = true;
      this.updateConnectionStatus("websocket");
      this.emit("websocketReady", this.ws);
    };
    this.ws.onclose = () => {
      log("ws.onclose");
      this.wsHealthy = false;
      this.updateConnectionStatus("authorized");
      this.emit("websocketClosed");
    };
    this.ws.onmessage = (e) => {
      const message = JSON.parse(e.data);
      this.handleWebsocketMessage(message);
    };
  }
  handleWebsocketMessage(message) {
    switch (message.messageType) {
      case "welcome":
        this.emit("welcome", message.payload);
        break;
      case "deviceUpdated":
        const payload = message.payload;
        if (this.lastUpdateId) {
          if (this.lastUpdateId == payload.updateId) {
            this.lastUpdateId = null;
            this.lastUpdateEpoch = null;
          } else {
            if (this.lastUpdateEpoch && Date.now() - this.lastUpdateEpoch > 1e3) {
              this.lastUpdateId = null;
              this.lastUpdateEpoch = null;
            } else {
              const timeRemaining = 1e3 - (Date.now() - this.lastUpdateEpoch);
              log(
                `ignoring update ${payload.updateId} because we are still waiting to see ${this.lastUpdateId} (time remaining: ${timeRemaining}ms))`
              );
              break;
            }
          }
        }
        payload.causedByThisApp = payload.triggeringAppId === this.appId;
        payload.causedByAnotherApp = payload.triggeringAppId !== this.appId && payload.triggeringAppId !== "vasconnect";
        payload.causedByVASConnect = payload.triggeringAppId === "vasconnect";
        this.emit("deviceUpdated", message.payload);
        break;
      case "deviceConnected":
        this.emit("deviceConnected", message.payload);
        break;
      case "deviceDisconnected":
        this.emit(
          "deviceDisconnected",
          message.payload
        );
        break;
    }
  }
  updateConnectionStatus(newConnectionStatus) {
    if (newConnectionStatus === this.connectionStatus) {
      return;
    }
    const oldConnectionStatus = this.connectionStatus;
    this.connectionStatus = newConnectionStatus;
    if (newConnectionStatus === "authorized") {
      this.initializeWebSocket();
    }
    this.emit(
      "connectionStatusChange",
      newConnectionStatus,
      oldConnectionStatus
    );
  }
  /**
   * Subscribes to connection status change events. Every time VASConnect.js has a status change, the callback
   * will be invoked with the new status. Possible statuses are: error, disconnected, unauthorized, authorizing, authorized, websocket
   * @param listener the callback which will be called whenever status changes
   * @example
   * ```
   * const vc = new VasConnect();
   * vc.onConnectionStatusChange((newStatus, oldStatus) => {
   *  console.log(`VASConnect status is now ${newStatus}. Previous status was ${oldStatus}`);
   * })
   *
   * ```
   */
  onConnectionStatusChange(listener) {
    this.on("connectionStatusChange", listener);
    return () => {
      this.off("connectionStatusChange", listener);
    };
  }
  onWebsocketReady(listener) {
    this.on("websocketReady", listener);
    return () => {
      this.off("websocketReady", listener);
    };
  }
  onWelcome(listener) {
    this.on("welcome", listener);
    return () => {
      this.off("welcome", listener);
    };
  }
  onDeviceUpdated(listener) {
    this.on("deviceUpdated", listener);
    return () => {
      this.off("deviceUpdated", listener);
    };
  }
  onDeviceConnected(listener) {
    this.on("deviceConnected", listener);
    return () => {
      this.off("deviceConnected", listener);
    };
  }
  onDeviceDisconnected(listener) {
    this.on("deviceDisconnected", listener);
    return () => {
      this.off("deviceDisconnected", listener);
    };
  }
  getWs() {
    return this.ws;
  }
  /**
   * Attempts to authorize this instance of VASConnect.js to communicate with the VASConnect thin client.
   * Calling this function will present a popup to the user asking them to confirm the authorization.
   * If the authorization is approved, you may begin using functions which require authorization, such as {@link listDevices} and {@link updateDevice}
   * @returns true if the authorization was successful
   * @example
   * ```
   * const vc = new VasConnect({
   *   licenseToken: "<your license token here>",
   *   authorizeAutomatically: false
   * });
   * 
   * // Later in your code
   * vc.authorize()
   *
   * ```
   */
  async authorize() {
    this.hasTriedToAuthorize = true;
    this.updateConnectionStatus("authorizing");
    try {
      try {
        this.serverVersion = await this.getServerVersion();
        log(`Connected to VASConnect version ${this.serverVersion}`);
      } catch (e) {
        // console.error("Failed to get server version", e);
        this.serverVersion = null;
      }
      let token = this.licenseToken;
      if (token.startsWith("online:")) {
        token = await this.checkinOnlineForToken(token);
      } else {
        this.checkinOnlineForToken(token);
        token = token.replace("offline:", "");
      }
      const result = await this.rh.makeRequest("/authorize", {
        method: "POST",
        body: {
          licenseToken: token,
          secret: this.rh.getSecret()
        }
      });
      if (!result.success) {
        this.updateConnectionStatus("unauthorized");
        return false;
      }
      this.rh.setSecret(result.secret);
      window.localStorage.setItem(LOCALSTORAGE_KEY, result.secret);
      window.localStorage.setItem(LOCALSTORAGE_KEY_APP_ID, this.appId);
      this.updateConnectionStatus("authorized");
      return true;
    } catch (e) {
      this.updateConnectionStatus("unauthorized");
      return false;
    }
  }
  /**
   * Checks if connection to the VASConnect thin client is possible or not. This can be used
   * to determine if the thin client is running or not.
   * Calling this function does not require authorization.
   * @returns true if connection was made successfully
   */
  async isConnected() {
    try {
      await this.rh.makeRequest("/ping");
      return true;
    } catch (e) {
      return false;
    }
  }
  /**
   * Checks if this instance of VASConnect.js is already authorized to use the VASConnect thin client
   * @returns true if authorized
   */
  async isAuthorized() {
    if (!this.rh.hasSecretSet) {
      return false;
    }
    return this.rh.makeRequest("/authorize");
  }
  /**
   * Retrieves the version string of the running VASConnect executable.
   * Calling this function does not require authorization.
   * @returns a string representing the version of the running VASConnect executable
   */
  async getServerVersion() {
    return this.rh.makeRequest("/version");
  }
  /**
   * Retrieves a list of connected devices.
   * Calls to this function before authorization will fail. See {@link authorize}
   * @returns array of objects representing connected devices
   */
  async listDevices() {
    return this.rh.makeRequest(`/devices`);
  }
  /**
   * Retrieves detailed information about a connected device, including setpoints, flows, and fan speed.
   * Calls to this function before authorization will fail. See {@link authorize}
   * @param deviceId the id of the device
   * @returns the device details after the update is completed
   */
  async getDeviceDetails(deviceId) {
    return this.rh.makeRequest(`/devices/${deviceId}`, {
      method: "GET"
    });
  }
  /**
   * Sends an update to a connected device, returning the device details after the update is completed.
   * Calls to this function before authorization will fail. See {@link authorize}
   * @param deviceId the id of the device to update
   * @param options an object containing any fields of the device you wish to update. Include the setpoints field as a number array
   * to update the device setpoints. Include the fanSpeed field as a number to change the fan speed between 0 and 100.
   * @returns the device details after the update is completed
   * @example
   * ```
   * const vc = new VasConnect();
   * const details = vc.updateDevice("0d360a3d-dfa1-4ad4-9cbb-bead2cf801c6", {
   *  setpoints: [10, 20, 30], // sets the first three flows, and zeroes any others
   *  fanSpeed: 75
   * });
   * ```
   */
  async updateDevice(deviceId, options) {
    const defaultTransit = this.wsHealthy ? "websocket" : "http";
    const transit = options.transit || defaultTransit;
    const updateId = uuidv4();
    if (transit === "http") {
      return this.rh.makeRequest(`/devices/${deviceId}`, {
        method: "PATCH",
        body: {
          setpoints: options.setpoints,
          fan_speed: options.fanSpeed
        }
      });
    } else {
      this.lastUpdateId = updateId;
      this.lastUpdateEpoch = Date.now();
      this.ws.send(
        JSON.stringify({
          messageType: "updateDevice",
          payload: {
            deviceId,
            updateId,
            setpoints: options.setpoints,
            fanSpeed: options.fanSpeed
          }
        })
      );
      return new Promise((resolve, reject) => {
        const listener = (event) => {
          if (event.updateId === updateId) {
            this.off("deviceUpdated", listener);
            resolve(event.device);
          }
        };
        this.on("deviceUpdated", listener);
      });
    }
  }
  async listApps() {
    return this.rh.makeRequest("/apps");
  }
  async getDiscoveryStatus() {
    return this.rh.makeRequest("/discovery");
  }
  async resetDiscovery() {
    return this.rh.makeRequest("/discovery/reset", { method: "POST" });
  }
  async showGui() {
    return this.rh.makeRequest("/gui/show", { method: "POST" });
  }
};
export {
  RequestHandler,
  VASConnect as default,
  getAppIdFromLicenseToken,
  log
};
/*! Bundled license information:

reconnecting-websocket/dist/reconnecting-websocket-mjs.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0
  
  THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.
  
  See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** *)
  (*!
   * Reconnecting WebSocket
   * by Pedro Ladaria <pedro.ladaria@gmail.com>
   * https://github.com/pladaria/reconnecting-websocket
   * License MIT
   *)
*/
